import React from 'react';
import { Field } from 'formik';
import { Dropdown, Label } from 'semantic-ui-react';
import _ from 'lodash'

const FormikDropdown = ({ name, label, options, dropdownOpen, handleOpen, handleClose, changeCategory }) => (
  <>
    <Label className='form-label'>{label}</Label>
    <Field name={name}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
      }) => (
        <Dropdown
          className={dropdownOpen ? 'no-radius-dropdown-open' : 'no-radius-dropdown'}
          onOpen={handleOpen}
          onClose={handleClose}
          text={label}
          clearable
          multiple
          search
          selection
          options={options}
          placeholder={label}
          value={_.isArray(field.value) ? field.value : [field.value]}
          onChange={(event, { value }) => {
            changeCategory(value)
          }}
          style={{ zIndex: "10000" }}
        />
      )}
    </Field>
  </>
);

export default FormikDropdown;
